import { FaExternalLinkAlt } from "react-icons/fa";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import {
  formatDateOnly,
  formatDateTime,
  formatPrice,
  formatUsd,
} from "../formatters";

const Metric = ({ label, value }) => (
  <div className="reddicks-token-metric">
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

const OwnedTokenMarketCard = ({ market, dexSiteUrl }) => {
  const isLive = market?.status === "live" || market?.status === "pair-only";
  const hasPairAddress = typeof market?.pairAddress === "string" && market.pairAddress;

  return (
    <div className="reddicks-token-card">
      <div className="reddicks-token-card-head">
        <div>
          <h4>{market?.label || "Token"}</h4>
          <p>{market?.pairLabel || "Official market unavailable"}</p>
        </div>
        {hasPairAddress ? (
          <a
            href={`https://www.radxplorer.com/components/${market.pairAddress}`}
            target="_blank"
            rel="noopener noreferrer"
            className="reddicks-token-link"
          >
            Pair
            <FaExternalLinkAlt className="h-3 w-3" />
          </a>
        ) : null}
      </div>

      <div className="reddicks-token-metrics">
        <Metric
          label="Current Price"
          value={formatPrice(market?.currentPrice, market?.priceUnit || "REDDICKS")}
        />
        <Metric
          label="Bid / Ask"
          value={`${formatPrice(market?.bidPrice, "", "N/A")} / ${formatPrice(
            market?.askPrice,
            "",
            "N/A",
          )}`}
        />
        <Metric label="TVL" value={formatUsd(market?.tvlUsd)} />
        <Metric label="Latest Volume" value={formatUsd(market?.latestVolumeUsd)} />
        <Metric label="Latest Fees" value={formatUsd(market?.latestFeesUsd)} />
        <Metric label="Pair Created" value={formatDateOnly(market?.pairCreatedAt)} />
      </div>

      <div className="reddicks-token-card-foot">
        <span>Last Pair Update: {formatDateTime(market?.updatedAt)}</span>
        <a href={dexSiteUrl} target="_blank" rel="noopener noreferrer">
          Open DEX
          <FaExternalLinkAlt className="h-3 w-3" />
        </a>
      </div>

      {!isLive ? (
        <p className="reddicks-token-fallback">
          Official pair analytics are unavailable right now.
        </p>
      ) : null}
    </div>
  );
};

const ReddicksTokenSections = ({ tokenMarkets, dexSiteUrl }) => {
  const reddicksFamily = tokenMarkets?.reddicks || {};

  return (
    <Card className="leaderboard-surface-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Owned Tokens and REDDICKS Ecosystem</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="leaderboard-data-hint leaderboard-data-hint-market">
          Focused on official-router REDDICKS, GBOF, and DCKSLAP markets.
        </p>
        <div className="reddicks-token-card reddicks-token-family">
          <div className="reddicks-token-card-head">
            <div>
              <h4>REDDICKS Ecosystem</h4>
              <p>Official-router REDDICKS pairs only</p>
            </div>
          </div>
          <div className="reddicks-token-metrics">
            <Metric label="Pair Count" value={`${reddicksFamily?.pairCount || 0}`} />
            <Metric
              label="Aggregate TVL"
              value={formatUsd(reddicksFamily?.aggregateTvlUsd)}
            />
            <Metric
              label="Largest Pair TVL"
              value={formatUsd(reddicksFamily?.largestPairTvlUsd)}
            />
            <Metric
              label="Latest Pair Created"
              value={formatDateOnly(reddicksFamily?.latestCreatedAt)}
            />
          </div>
        </div>

        <div className="reddicks-token-grid">
          <OwnedTokenMarketCard market={tokenMarkets?.gbof} dexSiteUrl={dexSiteUrl} />
          <OwnedTokenMarketCard
            market={tokenMarkets?.dckslap}
            dexSiteUrl={dexSiteUrl}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ReddicksTokenSections;
